import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-successful-payment',
  templateUrl: './successful-payment.component.html',
  styleUrls: ['./successful-payment.component.scss']
})
export class SuccessfulPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
